import { render } from "./DashboardPageUsb.vue?vue&type=template&id=589d7759&lang=html"
import script from "./DashboardPageUsb.vue?vue&type=script&lang=js"
export * from "./DashboardPageUsb.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__